module.exports = __webpack_public_path__ + "fonts/1e09f38.otf";